<template>
    <div class="traveler-component">
        <div class="title">
            {{ $t('f_passanger_title') }} {{ index + 1 }}
            <span class="remove icon icon-cross" @click="removeTraveler(traveler.id)" />
        </div>

        <span v-if="isPoaWarningShow" class="warning-message">
            {{ $t('f_fellow_travelers_warning') }}
        </span>

        <div class="own-input is_adult">
            <label :for="`traveler_child_${index}`" class="checkbox-container">
                {{ $t('f_under_18_label') }}
                <input
                    :id="`traveler_child_${index}`"
                    v-model="is_child"
                    type="checkbox">
                <span class="checkmark" />
            </label>
        </div>
        <div class="own-input">
            <label :for="`traveler_name_${index}`">{{ $t('f_name_label') }}</label>
            <input
                :id="`traveler_name_${index}`"
                v-model="traveler.name"
                v-validate="'required'"
                v-m-android-focus
                v-normalize
                v-capitalize
                :name="`travelers[${index}][name]`"
                :placeholder="$t('f_name_placeholder')"
                type="text">
            <span v-if="errors.first(`travelers[${index}][name]`)" class="error-message">
                {{ errors.first(`travelers[${index}][name]`) }}
            </span>
        </div>
        <div v-if="!is_child" class="own-input">
            <label :for="`traveler_email_${index}`">{{ $t('f_email_label') }}</label>
            <input
                :id="`traveler_email_${index}`"
                v-model="traveler.email"
                v-validate="'required|email'"
                v-m-android-focus
                v-normalize
                :name="`travelers[${index}][email]`"
                placeholder="your@email.com"
                type="email">
            <span v-if="errors.first(`travelers[${index}][email]`)" class="error-message">
                {{ errors.first(`travelers[${index}][email]`) }}
            </span>
        </div>
        <div v-if="is_child">
            <div class="own-input">
                <label :for="`traveler_pname_${index}`">{{ $t('f_name_of_parent_label') }}</label>
                <input
                    :id="`traveler_pname_${index}`"
                    v-model="traveler.parent_name"
                    v-validate="'required'"
                    v-m-android-focus
                    v-normalize
                    v-capitalize
                    :name="`travelers[${index}][parent_name]`"
                    :placeholder="$t('f_name_placeholder')"
                    type="text">
                <span v-if="errors.first(`travelers[${index}][parent_name]`)" class="error-message">
                    {{ errors.first(`travelers[${index}][parent_name]`) }}
                </span>
            </div>
            <div class="own-input">
                <label :for="`traveler_pemail_${index}`">{{ $t('f_email_of_parent_label') }}</label>
                <input
                    :id="`traveler_pemail_${index}`"
                    v-model="traveler.parent_email"
                    v-validate="'required|email'"
                    v-m-android-focus
                    v-normalize
                    :name="`travelers[${index}][parent_email]`"
                    placeholder="your@email.com"
                    type="email">
                <span v-if="errors.first(`travelers[${index}][parent_email]`)" class="error-message">
                    {{ errors.first(`travelers[${index}][parent_email]`) }}
                </span>
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    inject: ['$validator'],
    props: ['index', 'traveler'],
    data() {
      return {
        init: {
          name: this.traveler.name,
          email: this.traveler.email,
          parent_name: this.traveler.parent_name,
          parent_email: this.traveler.parent_email,
          is_adult: this.traveler.is_adult
        },
        isPoaWarningShow: false
      }
    },
    computed: {
        // checkbox reflects "is_child" but underlying model uses is_adult
        is_child: {
            get() {
                // treat undefined as false (adult unknown/new) => unchecked
                return this.traveler.is_adult === false
            },
            set(value) {
                // checked means child => is_adult = false; unchecked => true
                this.traveler.is_adult = value ? false : true
            }
        }
    },
    watch: {
      'traveler.name': 'checkPoaWarning',
      'traveler.email': 'checkPoaWarning',
      'traveler.parent_name': 'checkPoaWarning',
      'traveler.parent_email': 'checkPoaWarning',
      'traveler.is_adult': 'checkPoaWarning'
    },
    mounted() {
      this.checkPoaWarning();
    },
    methods: {
        checkPoaWarning() {
            const {traveler: t, init: i} = this;

            const is_adult_changed =
                    i.is_adult !== undefined && t.is_adult !== i.is_adult;

            const is_name_changed =
                    Boolean(i.name) && t.name !== i.name;

            let contact_changed = false;

            if (t.is_adult) {
                contact_changed = Boolean(i.email) && t.email !== i.email;
            } else {
                contact_changed =
                        (Boolean(i.parent_name) && t.parent_name !== i.parent_name) ||
                        (Boolean(i.parent_email) && t.parent_email !== i.parent_email);
            }

            this.isPoaWarningShow = is_adult_changed || is_name_changed || contact_changed;
        },
    removeTraveler: function (id) {
        if (window.confirm(this.$t('f_confirm_remove_traveler') || 'Are you sure you want to remove this traveler?')) {
            this.$validator.pause()
            this.$store.commit('travelers/REMOVE', id)
            this.$nextTick(() => this.$validator.resume())
        }
    }
    }
}
</script>

<style lang="scss">
  @import '~@stylesheets/_vars.scss';

  .traveler-component {
    .title {
      background-color: $light_gray_c;
      font-size: 18px !important;
      text-align: left;
      position: relative;
      padding: 12px 0;
      border: 1px solid $light_gray_a;
      .content {
        bottom: 43px;
      }
    }

    .is_adult {
      label {
        font-size: 15px;
        padding-top: 2px;
      }

      .checkmark {
        height: 22px;
        width: 22px;

        &:after {
          top: 3px;
          left: 7px;
        }
      }
    }
  }
</style>
